import Box from '@mui/material/Box';
import { useMemo } from 'react';
import { KanbanColumn } from './KanbanColumn';
import { ZoneAndHistory, ZoneStatus } from '@/__generated__/graphql';
import { ProgressBar } from './ProgressBar';

type Props = {
  zones: ZoneAndHistory[];
};

const columnContainerStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(5, 1fr)',
  gap: '1',
};

const statuses = Object.values(ZoneStatus);

export const KanbanViewer = ({ zones }: Props) => {
  const zoneCollections = useMemo(() => {
    return (
      statuses
        // Exclude ReviewReady from the list of statuses
        // since it will be merged with InReview
        .filter((st) => st !== ZoneStatus.ReviewReady)
        .map((status) => {
          return {
            status,
            zones: zones.filter((zone) => {
              if (status === ZoneStatus.InReview) {
                return (
                  zone.status === ZoneStatus.InReview || zone.status === ZoneStatus.ReviewReady
                );
              }
              return zone.status === status;
            }),
          };
        })
    );
  }, [zones]);

  const progressBarData = useMemo(() => {
    return statuses
      .map((status) => {
        return zones.filter((zone) => zone.status === status);
      })
      .map((zoneCollection, index) => ({
        status: statuses[index],
        numberOfZones: zoneCollection.length,
      }));
  }, [zones]);

  return (
    <>
      <ProgressBar data={progressBarData} />
      <Box sx={columnContainerStyle}>
        {zoneCollections.map((item) => (
          <KanbanColumn zones={item.zones} status={item.status} key={item.status} />
        ))}
      </Box>
    </>
  );
};
